<template>

  <div>


    <app-header />


    <div class="container">

      <div class="my-3">
        <h1>{{_lang('User')}}</h1>
      </div>

        <p>Name: {{ user.name }}</p>
        <p>E-mail: {{ user.email }}</p>
        <p>{{_lang('Language')}}: {{user.language}}</p>
        <p>{{_lang('Currency')}}: {{user.currency}}</p>


        <div class="d-flex align-items-center mt-5"><h3 >{{_lang('Plan')}}</h3><a href="#" class="ml-3" @click.prevent="openModal('plansBRL')">{{_lang('options')}}</a></div>
        <hr>
        <p>{{_lang('Basic')}} <strong v-if="user.business_id!=7">({{_lang('current')}})</strong></p>
        <p>{{_lang('Agency')}} <strong v-if="user.business_id==7">({{_lang('current')}})</strong></p>


        <h3>{{_lang('Payment method')}}</h3>

        <div v-if="user.external_id">
          {{_lang('Credit card')}} <button class="btn btn-small" @click.prevent="openModal('payment')">{{_lang('change')}}</button>
        </div>
        <div v-else>
          <button class="btn btn-primary" @click.prevent="openModal('payment')">{{_lang('Configure')}}</button>
        </div>

        <h3 class="mt-5">{{_lang('Balance')}}</h3>
        <hr>

        <p>{{_lang('Balance')}}: <strong>{{balance}} {{user.currency}}</strong></p>

<!--
        <div class="card-deck cards-topup">
          <div class="card">

              <div class="card-body">
                <h5 class="card-title">Top up {{currency.symbol}}10</h5>
              </div>
              <div class="card-footer">
                <div id="paypal-button-container10"></div>
             </div>

          </div>

          <div class="card">

              <div class="card-body">
                <h5 class="card-title">Top up {{currency.symbol}}100</h5>
              </div>
              <div class="card-footer">
                <div id="paypal-button-container100"></div>
             </div>

          </div>

        </div>
        -->

        <h3 class="mt-5">{{_lang('History')}}</h3>
        <hr>
        <div class="btn-group">
          <button class="btn btn-light" @click="previousMonth">&lt;</button>
          <button class="btn btn-light">{{ monthName(month) }}</button>
          <button class="btn btn-light" @click="nextMonth">&gt;</button>
        </div>
        <table class="table">
          <thead>
            <tr>
              <th>{{_lang('Date')}}</th>
              <th>{{_lang('Description')}}</th>
              <th>{{_lang('Amount')}}</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="transaction in transactions">
                <td>{{ transaction.created_at.replace(/ .*/,'') }}</td>
                <td>{{transaction.description}}</td>
                <td>{{transaction.amount}} {{transaction.currency}}</td>
                <td><button class="btn btn-light btn-sm" @click="detailDay(transaction.created_at)">{{_lang('Detail')}}</button></td>
              </tr>
            </tbody>
        </table>


        <div class="mt-5 mb-5">
          <router-link class="btn btn-light" to="/">{{_lang('Back')}}</router-link>
        </div>


    </div>


    <div class="modal modal-active modal-plans" v-if="isOpenModal('payment')">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title">{{_lang('Credit card')}}</div>
            <span class="close" @click="closeModal">&times;</span>
         </div>
         <div class="modal-body">
           <UserPayment />
         </div>
        </div>
      </div>
    </div>



    <div class="modal modal-active modal-plans" v-if="isOpenModal('plansUSD')">
      <div class="modal-dialog">
         <div class="modal-content">
           <div class="modal-header">
             <div class="modal-title">Plans</div>
             <span class="close" @click="closeModal">&times;</span>
          </div>
           <div class="modal-body">

             <div class="row">
               <div class="col-lg-6">
                  <ul class="list-group">
                    <li class="list-group-item"><strong>Starter</strong></li>
                    <li class="list-group-item">No montly fee</li>
                    <li class="list-group-item">$7/month/website</li>
                    <li class="list-group-item">E-mail support</li>
                  </ul>
                </div>
                <div class="col-lg-6">

                  <ul class="list-group">
                    <li class="list-group-item"><strong>Agency</strong></li>
                    <li class="list-group-item">$70 monthly</li>
                    <li class="list-group-item">+ $5/month/website</li>
                    <li class="list-group-item">E-mail and Chat support</li>
                  </ul>
                </div>
              </div>

           </div>
         </div>
       </div>
    </div>

  <div class="modal modal-active modal-plans" v-if="isOpenModal('plansBRL')">
      <div class="modal-dialog">
         <div class="modal-content">
           <div class="modal-header">
             <div class="modal-title">Plano</div>
             <span class="close" @click="closeModal">&times;</span>
          </div>
           <div class="modal-body">

             <div class="row">
               <div class="col-lg-6">
                  <ul class="list-group">
                    <li class="list-group-item"><strong>Básico</strong></li>
                    <li class="list-group-item">Sem taxa mensal</li>
                    <li class="list-group-item">R$ 30,00/mês/website</li>
                    <li class="list-group-item">Suporte por e-mail</li>
                  </ul>
                </div>
                <div class="col-lg-6">

                  <ul class="list-group">
                    <li class="list-group-item"><strong>Agência</strong></li>
                    <li class="list-group-item">R$ 370,00 mensais</li>
                    <li class="list-group-item">+ R$ 20,00/mês/website</li>
                    <li class="list-group-item">Suporte por e-mail, chat, Whatsapp</li>
                  </ul>
                </div>
              </div>

           </div>
         </div>
       </div>
    </div>

<div class="modal modal-active" v-if="isOpenModal('dayTransactions')">
      <div class="modal-dialog">
         <div class="modal-content">
           <div class="modal-header">
             <div class="modal-title">{{month}}-{{day}}</div>
             <span class="close" @click="closeModal">&times;</span>
          </div>
           <div class="modal-body">

            <table class="table">
              <thead>
                <tr>
                  <th>{{_lang('Date')}}</th>
                  <th>{{_lang('Description')}}</th>
                  <th>{{_lang('Amount')}}</th>
                </tr>
                </thead>
                <tbody>
                  <tr v-for="transaction in dayTransactions">
                    <td>{{ transaction.created_at.replace(/ .*/,'') }}</td>
                    <td>{{transaction.description}}</td>
                    <td>{{transaction.amount}} {{transaction.currency}}</td>
                  </tr>
                </tbody>
            </table>



           </div>
         </div>
       </div>
    </div>


  </div>


</template>
<script>

  import axios from 'axios';

  import appHeader from '../components/appHeader.vue';
  import UserPayment from './payment/UserPayment.vue';

  export default {
    name: 'user',
    components:{
      appHeader,
      UserPayment
    },
    data() {
      return {
        modalActive:'',
        transactions:[],
        month:'',
        day:'',
        balance:'',
        dayTransactions:[],

      }
    },
    computed:{
        user(){
            return this.$store.getters.user;
        },
    },
    methods:{

      monthName(month){
        var aux = this.month.split('-');
        var year = aux[0];
        var month = parseInt(aux[1]);
        var names = ['','Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dec'];
        return year+'-'+names[month];
      },
      detailDay(date){
        var match = date.match(/^(\d+-\d+)-(\d+)/)
        var month = match[1];
        var day = match[2];

        this.day = day;
        this.$store.dispatch('startLoading');
        axios.get('/api/transactions/'+month+'/'+day).then(res=>{
          this.openModal('dayTransactions');
          this.dayTransactions = res.data;
          this.$store.dispatch('stopLoading');
        })

      },

      isOpenModal(id){
        return this.modalActive ==id;
      },
      closeModal(){

        this.modalActive = '';
      },
      openModal(id){
        this.modalActive = id;
      },

      previousMonth(){
        var aux = this.month.split('-');
        var year = parseInt(aux[0]);
        var month = parseInt(aux[1])-1;
        if(month==0){
          month = 12;
          year = year-1;
        }
        month = ('0'+month).substr(-2);
        this.month = year+'-'+month;
        this.getMonth(this.month);
      },
      nextMonth(){
        var aux = this.month.split('-');
        var year = parseInt(aux[0]);
        var month = parseInt(aux[1])+1;
        if(month==13){
          month = 1;
          year = year+1;
        }
        month = ('0'+month).substr(-2);
        this.month = year+'-'+month;
        this.getMonth(this.month);
      },
      getMonth(month){
        this.$store.dispatch('startLoading');
        axios.get('/api/transactions/'+month).then(res=>{
          this.transactions = res.data;
        }).finally(()=>{
          this.$store.dispatch('stopLoading');
        })
      }

    },
    mounted(){

      var today = new Date();
      var year = today.getFullYear();
      var month = today.getMonth()+1;
      month = ('0'+month).substr(-2);

      this.month = year+'-'+month;


      axios.get('/api/transactions/balance').then(res=>{
        this.balance = res.data;
      });

      this.getMonth(this.month);

    }

  }



</script>

<style scoped>

table { min-width:50%;}

.modal-active { display: block; }
.modal-plans .modal-dialog { max-width:700px;}

.modal { background-color:rgba(0,0,0,.2);}

@media(max-width:991px){
  .col-lg-6 + .col-lg-6 { margin-top:20px; }
}

.cards-topup .card { max-width:250px;}
.cards-topup .card-title {
    font-size:26px;
    text-align:center;
  }
</style>
